import React from "react";
import { Box, Typography, Tooltip } from "@mui/material";
import DoubleCheckIcon from "./DoubleCheckIcon.jsx";

const ReadReceipt = ({ isLastRead, isRead, readAt, currentUser }) => {
  if (!currentUser) return null;

  const name = currentUser.name || currentUser.firstName || "User";
  
  if (isLastRead) {
    const label = readAt
      ? `Seen by ${name} at ${new Date(readAt).toLocaleString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: true })}`
      : `Seen by ${name}`;

    return (
      <Tooltip title={label} arrow placement="top">
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            px: "6px",
            py: "3px",
            borderRadius: "5px", // Slight curve
            background: "rgba(15, 23, 42, 0.03)",
            border: "1px solid rgba(15, 23, 42, 0.08)",
            marginTop: "3px",
            marginBottom: "3px",
            marginRight: "4px",
            cursor: "default",
            transition: "all 0.2s ease",
            "&:hover": {
              background: "rgba(15, 23, 42, 0.05)",
              borderColor: "rgba(15, 23, 42, 0.12)",
            }
          }}
        >
          <Typography
            sx={{
              fontSize: "9px",
              fontWeight: 600,
              color: "#64748B",
              fontFamily: "'Inter', sans-serif",
              lineHeight: 1,
              letterSpacing: "0.02em",
            }}
          >
            Read by {name}
          </Typography>
        </Box>
      </Tooltip>
    );
  }

  // Render a double checkmark below the bubble for previous/unread messages
  const checkLabel = isRead
    ? `Seen by ${name}`
    : `Delivered`;

  return (
    <Tooltip title={checkLabel} arrow placement="top">
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          marginTop: "2px",
          marginBottom: "4px",
          marginRight: "6px",
          cursor: "default",
        }}
      >
        <DoubleCheckIcon color={isRead ? "#0284c7" : "#94a3b8"} />
      </Box>
    </Tooltip>
  );
};

export default ReadReceipt;
